import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'bookings',
    lazy: async () => ({ Component: (await import('./BookingsPage')).BookingsPage }),
  },
];
